import api from './api';

export interface AdminStoreItem {
  _id: string;
  name: string;
}

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pages: number;
  limit: number;
}

const storeAdminService = {
  async searchStores(name: string, page = 1, limit = 10): Promise<Paginated<AdminStoreItem>> {
    const params: any = { page, limit };
    if (name) params.name = name;
    const raw: any = await api.get<any>('/admin/stores', { params } as any);
    // raw.success + raw.data with { docs/items } formats
    const data = raw?.data || raw;
    const items = data?.docs || data?.items || [];
    const total = data?.totalDocs || data?.total || 0;
    const pages = data?.totalPages || data?.pages || Math.ceil(total / (data?.limit || limit)) || 1;
    const currentPage = data?.page || page;
    const lmt = data?.limit || limit;
    return { items, total, page: currentPage, pages, limit: lmt };
  }
};

export default storeAdminService;


